/**
 * Usage:
 * You can write a var or function in component
 *
 * eg:
 * title: 'Ein Titel...'
 * or
 * title: () => return 'Ein Title...'
 */

const defaultTitle = 'meine.pflege.de - Ihr digitaler Pflegeassistent';

function getTitle(vm) {
  const { title } = vm.$options;
  if (title) {
    return typeof title === 'function' ? title.call(vm) : title + ' | ' + defaultTitle;
  }
}

export default {
  created() {
    const title = getTitle(this);

    /**
     * Workaround.
     * Every component calls this mixin. But just allowed in "views"
     * A "view" component has a "v-" prefix for classes
     */

    if (this.el?.includes('v-')) {
      document.title = title || defaultTitle;
    }
  },
};
